module.exports = __webpack_public_path__ + "img/error.5aeba724.png";